import {ItemPresenterStyleConfigs} from "../ItemPresenter";

class ItemShowCasingStyling {
  itemPresenterStyleConfigs: ItemPresenterStyleConfigs = {
    imageWidth: "0",
    imagePreview: false
  }
}

export default ItemShowCasingStyling;